import { addMultiSelectValue, parseMultiSelectRef, removeMultiSelectValue } from "../view/multiSelectHelpers";




const multiSelectActionHandler = (getNodeForNodeId, template, renderView) => {
    const getControlNode = (controlNodeId) => {
        const controlNode = getNodeForNodeId(controlNodeId);

        if (!controlNode) {
            throw new Error('Could not find context for multiselect control');
        }

        return controlNode;
    };

    const handleSelect = async ({ ref, controlNodeId, value }) => {
        await addMultiSelectValue(
            getControlNode(controlNodeId),
            parseMultiSelectRef(ref, template.getNamespaceManager()),
            value,
        );
    };

    const handleDeselect = ({ ref, controlNodeId, value }) => {
        removeMultiSelectValue(
            getControlNode(controlNodeId),
            ref,
            value,
        );
    };

    const handleMultiSelectClick = async ({ props }) => {
        if (props.select) {
            await handleSelect(props);
        } else {
            handleDeselect(props);
        }

        await renderView();
    };

    return { handleMultiSelectClick };
};


export default multiSelectActionHandler;